"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _react = _interopRequireDefault(require("react"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _ArrayHelper = require("../../../../helpers/ArrayHelper");

var _UserService = _interopRequireDefault(require("../services/UserService"));

var _FeatureManager = _interopRequireDefault(require("../../../../utils/features/FeatureManager"));

var _RegisterInstance = _interopRequireDefault(require("../../../../KESI2/Services/RegisterInstance"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../../helpers/DeviceInfoHelper"));

// noinspection Eslint
// eslint-disable-line

/*
function EquizzerActions () {
  return Reflux.createActions([
    'initThemeStore',
    'initQuiz',
    'setUser',
    'setUserPoints',
    'setUserAuth',
    'setGroupUsers',
    'setOpponent',
    'setOpponentsList',
    'updateOpponentsList',
    'setCategoriesList',
    'setCategory',
    'getOpponent',
    'setCurrentQuestionStatus',
    'updateGame',
    'updateGameInAllGames',
    'setAllGame',
    'updateCompletedGameIds',
    'updateExpiredGameIds',
    'setNetworkStatus',
    'setActivatedFeatures',
    'deleteStore',
    'addActivatedFeature',
    'setHistoryBasedFeedback',
    'setLeagueName',
    'setSeasons',
    'setLearningState',
    'setUserPresences',
    'setShowPresences'
  ])
}

// noinspection Eslint
module.exports = window.QuizActions = new EquizzerActions(); // eslint-disable-line
*/
var EquizzerActions = /*#__PURE__*/function () {
  function EquizzerActions() {
    (0, _classCallCheck2["default"])(this, EquizzerActions);
  }

  (0, _createClass2["default"])(EquizzerActions, null, [{
    key: "initUser",
    value: function () {
      var _initUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var skipFeatureCheck,
            feature,
            userAuth,
            newUser,
            subjectId,
            currentSubject,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                skipFeatureCheck = _args.length > 0 && _args[0] !== undefined ? _args[0] : false;
                _context.next = 3;
                return _FeatureManager["default"].getFeatureWaitingForStore('equeoqd');

              case 3:
                feature = _context.sent;

                if (!_config["default"].useDrupalContent) {
                  _context.next = 12;
                  break;
                }

                _context.t1 = "Bearer ";
                _context.next = 8;
                return _RegisterInstance["default"].getAccessToken('quizUser:read quizUser:write quizGroup:read quizGame:read quizGame:write');

              case 8:
                _context.t2 = _context.sent;
                _context.t0 = _context.t1.concat.call(_context.t1, _context.t2);
                _context.next = 13;
                break;

              case 12:
                _context.t0 = feature && feature.additionalData && feature.additionalData._auth ? feature.additionalData._auth : null;

              case 13:
                userAuth = _context.t0;

                if (!(!skipFeatureCheck && (!feature || !feature.userId || !feature.additionalData || !userAuth))) {
                  _context.next = 16;
                  break;
                }

                throw new Error('NO_FEATURE_DONT_SHOW');

              case 16:
                if (!_DeviceInfoHelper["default"].isOnline()) {
                  _context.next = 24;
                  break;
                }

                _context.next = 19;
                return _UserService["default"].preload(feature.userId, userAuth);

              case 19:
                newUser = _context.sent;
                _context.next = 22;
                return EquizzerActions.setUser(newUser, 'initUser');

              case 22:
                _context.next = 25;
                break;

              case 24:
                newUser = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_USER);

              case 25:
                if (newUser) {
                  _context.next = 27;
                  break;
                }

                throw new Error('Unable to get User');

              case 27:
                if (!newUser.playgroupId) {
                  _context.next = 30;
                  break;
                }

                _context.next = 30;
                return EquizzerActions.setGroupId(newUser.playgroupId);

              case 30:
                if (!newUser.points) {
                  _context.next = 35;
                  break;
                }

                _context.next = 33;
                return EquizzerActions.setUserPoints(newUser.points);

              case 33:
                _context.next = 41;
                break;

              case 35:
                subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);

                if (!subjectId) {
                  _context.next = 41;
                  break;
                }

                currentSubject = newUser.subjects.find(function (subject) {
                  return subject.emsId === subjectId;
                });

                if (!currentSubject) {
                  _context.next = 41;
                  break;
                }

                _context.next = 41;
                return EquizzerActions.setUserPoints(currentSubject.points);

              case 41:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function initUser() {
        return _initUser.apply(this, arguments);
      }

      return initUser;
    }()
  }, {
    key: "initQuiz",
    value: function () {
      var _initQuiz = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(game) {
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GAME, game, false);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function initQuiz(_x) {
        return _initQuiz.apply(this, arguments);
      }

      return initQuiz;
    }()
  }, {
    key: "getActivatedFeatures",
    value: function getActivatedFeatures() {
      return _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_ACTIVATED_FEATURES);
    }
  }, {
    key: "isActivatedFeature",
    value: function isActivatedFeature(featureName) {
      var activatedFeatures = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_ACTIVATED_FEATURES);

      return activatedFeatures && activatedFeatures.includes(featureName);
    }
  }, {
    key: "addActivatedFeature",
    value: function () {
      var _addActivatedFeature = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(activatedFeature) {
        var activatedFeatures;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                console.log("setting the following feature as active: ".concat(activatedFeature)); // this.state.activatedFeatures = this.state.activatedFeatures.concat(activatedFeature)
                // this.trigger(this.state)

                activatedFeatures = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_ACTIVATED_FEATURES) || [];
                _context3.next = 4;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_ACTIVATED_FEATURES, activatedFeatures.concat(activatedFeature), false);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function addActivatedFeature(_x2) {
        return _addActivatedFeature.apply(this, arguments);
      }

      return addActivatedFeature;
    }()
  }, {
    key: "removeActivatedFeature",
    value: function () {
      var _removeActivatedFeature = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(activatedFeatureName) {
        var activatedFeatures, index;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                console.log("removing the following feature as active: ".concat(activatedFeatureName)); // this.state.activatedFeatures = this.state.activatedFeatures.concat(activatedFeature)
                // this.trigger(this.state)

                activatedFeatures = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_ACTIVATED_FEATURES) || [];
                index = activatedFeatures.indexOf(activatedFeatureName);

                if (!(index !== -1)) {
                  _context4.next = 8;
                  break;
                }

                (0, _ArrayHelper.removeElementAtPosition)(activatedFeatures, index);
                console.log('updated features after removing', activatedFeatures);
                _context4.next = 8;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_ACTIVATED_FEATURES, activatedFeatures, false);

              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function removeActivatedFeature(_x3) {
        return _removeActivatedFeature.apply(this, arguments);
      }

      return removeActivatedFeature;
    }()
  }, {
    key: "setActivatedFeatures",
    value: function () {
      var _setActivatedFeatures = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(activatedFeatures) {
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                console.log("setting the following features as active: ".concat((0, _stringify["default"])(activatedFeatures))); // this.setState(activatedFeatures)

                _context5.next = 3;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_ACTIVATED_FEATURES, activatedFeatures, false);

              case 3:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      function setActivatedFeatures(_x4) {
        return _setActivatedFeatures.apply(this, arguments);
      }

      return setActivatedFeatures;
    }()
  }, {
    key: "setGroupUsers",
    value: function () {
      var _setGroupUsers = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(groupUsers) {
        return _regenerator["default"].wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS, groupUsers, false);

              case 2:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      function setGroupUsers(_x5) {
        return _setGroupUsers.apply(this, arguments);
      }

      return setGroupUsers;
    }()
  }, {
    key: "setUser",
    value: function () {
      var _setUser = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(user, caller) {
        return _regenerator["default"].wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_USER, user, true);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function setUser(_x6, _x7) {
        return _setUser.apply(this, arguments);
      }

      return setUser;
    }()
  }, {
    key: "setGroupId",
    value: function () {
      var _setGroupId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(groupId) {
        return _regenerator["default"].wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GROUP_ID, groupId, false);

              case 2:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      function setGroupId(_x8) {
        return _setGroupId.apply(this, arguments);
      }

      return setGroupId;
    }()
  }, {
    key: "setSubjectId",
    value: function () {
      var _setSubjectId = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(subjectId) {
        return _regenerator["default"].wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID, subjectId, false);

              case 2:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }));

      function setSubjectId(_x9) {
        return _setSubjectId.apply(this, arguments);
      }

      return setSubjectId;
    }()
  }, {
    key: "setSubjects",
    value: function () {
      var _setSubjects = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee10(subjectList) {
        return _regenerator["default"].wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_SUBJECTS, subjectList, false);

              case 2:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }));

      function setSubjects(_x10) {
        return _setSubjects.apply(this, arguments);
      }

      return setSubjects;
    }()
  }, {
    key: "setUserSubjects",
    value: function () {
      var _setUserSubjects = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee11(subjectList) {
        return _regenerator["default"].wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_USER_SUBJECTS, subjectList, false);

              case 2:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      function setUserSubjects(_x11) {
        return _setUserSubjects.apply(this, arguments);
      }

      return setUserSubjects;
    }()
  }, {
    key: "setUserPoints",
    value: function () {
      var _setUserPoints = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee12(points) {
        return _regenerator["default"].wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_USER_POINTS, points, false);

              case 2:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      function setUserPoints(_x12) {
        return _setUserPoints.apply(this, arguments);
      }

      return setUserPoints;
    }()
  }, {
    key: "setUserAuth",
    value: function () {
      var _setUserAuth = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee13(user) {
        return _regenerator["default"].wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_USER_AUTH, user, false);

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      function setUserAuth(_x13) {
        return _setUserAuth.apply(this, arguments);
      }

      return setUserAuth;
    }()
  }, {
    key: "setOpponentsList",
    value: function () {
      var _setOpponentsList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee14(opponents) {
        return _regenerator["default"].wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_OPPONENTS, opponents, false);

              case 2:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      function setOpponentsList(_x14) {
        return _setOpponentsList.apply(this, arguments);
      }

      return setOpponentsList;
    }()
  }, {
    key: "updateOpponentsList",
    value: function () {
      var _updateOpponentsList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee15(opponent) {
        var opponents, oldOpponentIndex, groupUsers, oldGroupUserIndex, data;
        return _regenerator["default"].wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                opponents = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_OPPONENTS);
                oldOpponentIndex = opponents.findIndex(function (user) {
                  return user.id === opponent.id;
                });
                opponents[oldOpponentIndex] = opponent;
                groupUsers = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS);
                oldGroupUserIndex = groupUsers.findIndex(function (user) {
                  return user.id === opponent.id;
                });
                groupUsers[oldGroupUserIndex] = opponent;
                data = {};
                data[_DataStore.DATA_STORE_PATHS.QD_OPPONENTS] = opponents;
                data[_DataStore.DATA_STORE_PATHS.QD_GROUP_USERS] = groupUsers;
                _context15.next = 11;
                return _DataStore["default"].setData(data, false);

              case 11:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      function updateOpponentsList(_x15) {
        return _updateOpponentsList.apply(this, arguments);
      }

      return updateOpponentsList;
    }()
  }, {
    key: "setAllGame",
    value: function () {
      var _setAllGame = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee16(allGame) {
        var newGames, games;
        return _regenerator["default"].wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                newGames = [];
                games = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_ALL_GAME) || [];
                allGame.forEach(function (game) {
                  var localGame = games.find(function (oldGame) {
                    return game.id === oldGame.id;
                  });
                  var gameToSave = localGame && localGame.isDirty ? localGame : game;
                  console.log('STORE: allGame game', game, localGame, gameToSave);
                  newGames.push(gameToSave);
                }); // this.setState({allGame: newGames})

                _context16.next = 5;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_ALL_GAME, newGames, false);

              case 5:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16);
      }));

      function setAllGame(_x16) {
        return _setAllGame.apply(this, arguments);
      }

      return setAllGame;
    }()
  }, {
    key: "setOpponent",
    value: function () {
      var _setOpponent = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee17(opponent) {
        return _regenerator["default"].wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_SELECTED_OPPONENT, opponent, false);

              case 2:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      function setOpponent(_x17) {
        return _setOpponent.apply(this, arguments);
      }

      return setOpponent;
    }()
  }, {
    key: "setCategoriesList",
    value: function () {
      var _setCategoriesList = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee18(categories) {
        return _regenerator["default"].wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_CATEGORIES, categories, false);

              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      function setCategoriesList(_x18) {
        return _setCategoriesList.apply(this, arguments);
      }

      return setCategoriesList;
    }()
  }, {
    key: "setCategory",
    value: function () {
      var _setCategory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee19(category) {
        return _regenerator["default"].wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_CATEGORIES, category, false);

              case 2:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      function setCategory(_x19) {
        return _setCategory.apply(this, arguments);
      }

      return setCategory;
    }()
  }, {
    key: "setCurrentQuestionStatusNumber",
    value: function () {
      var _setCurrentQuestionStatusNumber = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee20(number) {
        return _regenerator["default"].wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_CURRENT_QUESTION_STATUS_NUMBER, number, false);

              case 2:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      function setCurrentQuestionStatusNumber(_x20) {
        return _setCurrentQuestionStatusNumber.apply(this, arguments);
      }

      return setCurrentQuestionStatusNumber;
    }()
  }, {
    key: "setLeagueName",
    value: function () {
      var _setLeagueName = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee21() {
        var leagueName,
            _args21 = arguments;
        return _regenerator["default"].wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                leagueName = _args21.length > 0 && _args21[0] !== undefined ? _args21[0] : null;
                _context21.next = 3;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_LEAGUE_NAME, leagueName, false);

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      function setLeagueName() {
        return _setLeagueName.apply(this, arguments);
      }

      return setLeagueName;
    }()
  }, {
    key: "updateGame",
    value: function () {
      var _updateGame = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee22(game) {
        return _regenerator["default"].wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_GAME, game, false);

              case 2:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      function updateGame(_x21) {
        return _updateGame.apply(this, arguments);
      }

      return updateGame;
    }()
  }, {
    key: "updateGameInAllGames",
    value: function () {
      var _updateGameInAllGames = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee23(game) {
        var force,
            games,
            elementPos,
            _args23 = arguments;
        return _regenerator["default"].wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                force = _args23.length > 1 && _args23[1] !== undefined ? _args23[1] : false;
                // compare if new objects are newer than stored objects
                games = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_ALL_GAME);
                elementPos = games.map(function (oldGame) {
                  return oldGame.id;
                }).indexOf(game.id);

                if (!(elementPos >= 0)) {
                  _context23.next = 11;
                  break;
                }

                if (!(!games[elementPos].isDirty || force)) {
                  _context23.next = 9;
                  break;
                }

                console.log('STORE: Newer game from server for local game -> update');
                games[elementPos] = game; // this.setState({allGame: games})

                _context23.next = 9;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_ALL_GAME, games, false);

              case 9:
                _context23.next = 15;
                break;

              case 11:
                console.log('STORE: not in all games yet -> update');
                games.push(game); // this.setState({allGame: games})

                _context23.next = 15;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_ALL_GAME, games, false);

              case 15:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      function updateGameInAllGames(_x22) {
        return _updateGameInAllGames.apply(this, arguments);
      }

      return updateGameInAllGames;
    }()
  }, {
    key: "updateCompletedGameIds",
    value: function () {
      var _updateCompletedGameIds = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee24(completedGameIds) {
        return _regenerator["default"].wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_COMPLETED_GAME_IDS, completedGameIds, false);

              case 2:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      function updateCompletedGameIds(_x23) {
        return _updateCompletedGameIds.apply(this, arguments);
      }

      return updateCompletedGameIds;
    }()
  }, {
    key: "updateExpiredGameIds",
    value: function () {
      var _updateExpiredGameIds = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee25(expiredGameIds) {
        return _regenerator["default"].wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_EXPIRED_GAME_IDS, expiredGameIds, false);

              case 2:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      function updateExpiredGameIds(_x24) {
        return _updateExpiredGameIds.apply(this, arguments);
      }

      return updateExpiredGameIds;
    }()
  }, {
    key: "setNetworkStatus",
    value: function () {
      var _setNetworkStatus = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee26(status) {
        return _regenerator["default"].wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_NETWORK_STATUS, status, false);

              case 2:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26);
      }));

      function setNetworkStatus(_x25) {
        return _setNetworkStatus.apply(this, arguments);
      }

      return setNetworkStatus;
    }()
  }, {
    key: "setHistoryBasedFeedback",
    value: function () {
      var _setHistoryBasedFeedback = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee27(historyBasedFeedback) {
        var objToSave;
        return _regenerator["default"].wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                if (!historyBasedFeedback) {
                  _context27.next = 6;
                  break;
                }

                objToSave = {};
                (0, _keys["default"])(historyBasedFeedback).forEach(function (key) {
                  var regex = "^".concat(key.replace(/\*/g, '.*'), "$");
                  objToSave[regex] = historyBasedFeedback[key];
                });
                console.log('setting learning distance feedback', objToSave); // this.setState({historyBasedFeedback: objToSave})

                _context27.next = 6;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_HISTORY_BASED_FEEDBACK, historyBasedFeedback, false);

              case 6:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      function setHistoryBasedFeedback(_x26) {
        return _setHistoryBasedFeedback.apply(this, arguments);
      }

      return setHistoryBasedFeedback;
    }()
  }, {
    key: "setSeasons",
    value: function () {
      var _setSeasons = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee28(seasons) {
        return _regenerator["default"].wrap(function _callee28$(_context28) {
          while (1) {
            switch (_context28.prev = _context28.next) {
              case 0:
                _context28.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_SEASONS, seasons, false);

              case 2:
              case "end":
                return _context28.stop();
            }
          }
        }, _callee28);
      }));

      function setSeasons(_x27) {
        return _setSeasons.apply(this, arguments);
      }

      return setSeasons;
    }()
  }, {
    key: "setLearningState",
    value: function () {
      var _setLearningState = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee29(learningStateByCategory) {
        return _regenerator["default"].wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                _context29.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_LEARNING_STATE, learningStateByCategory, false);

              case 2:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));

      function setLearningState(_x28) {
        return _setLearningState.apply(this, arguments);
      }

      return setLearningState;
    }()
  }, {
    key: "setUserPresences",
    value: function () {
      var _setUserPresences = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee30(presencesByNickname) {
        return _regenerator["default"].wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _context30.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_PRESENCES, presencesByNickname, false);

              case 2:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30);
      }));

      function setUserPresences(_x29) {
        return _setUserPresences.apply(this, arguments);
      }

      return setUserPresences;
    }()
  }, {
    key: "setShowPresences",
    value: function () {
      var _setShowPresences = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee31(showPresences) {
        return _regenerator["default"].wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return _DataStore["default"].setSingleData(_DataStore.DATA_STORE_PATHS.QD_SHOW_PRESENCES, showPresences, false);

              case 2:
                _DataStore["default"].onShowPresencesListeners.forEach(function (listener) {
                  listener(showPresences);
                });

              case 3:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));

      function setShowPresences(_x30) {
        return _setShowPresences.apply(this, arguments);
      }

      return setShowPresences;
    }()
  }]);
  return EquizzerActions;
}();

var _default = EquizzerActions;
exports["default"] = _default;